(() => {
  'use strict';
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  const desktop = matchMedia('(min-width: 901px)');
  const init = (scope = document) => {
    scope.querySelectorAll('[data-stx-gallery]').forEach(root => {
      if (root.dataset.stxReady) return;
      root.dataset.stxReady = 'true';
      const link = root.querySelector('[data-stx-image-link]');
      const action = root.querySelector('.stx-image-action');
      const primary = root.querySelector('.stx-image-main');
      const controls = root.querySelector('[data-stx-controls]');
      if (!link || !action || !primary || !controls) return;
      controls.hidden = false;
      let chosen = 0;
      let requested = 0;
      let start = null;
      let lastSwipe = -Infinity;
      const display = index => {
        requested = index;
        if (index === 1 && !action.complete) {
          action.loading = 'eager';
          return;
        }
        if (index === 1 && !action.naturalWidth) return;
        root.classList.toggle('is-action', index === 1);
        primary.setAttribute('aria-hidden', String(index === 1));
        action.setAttribute('aria-hidden', String(index !== 1));
        controls.querySelectorAll('[data-stx-view]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.stxView) === index)));
      };
      action.addEventListener('load', () => display(requested));
      action.addEventListener('error', () => {
        chosen = 0; requested = 0;
        root.classList.remove('is-action');
        primary.removeAttribute('aria-hidden');
        action.setAttribute('aria-hidden', 'true');
        controls.hidden = true;
      });
      controls.querySelectorAll('[data-stx-view]').forEach(button => button.addEventListener('click', () => {
        chosen = Number(button.dataset.stxView);
        display(chosen);
      }));
      link.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && finePointer.matches) display(1);
      });
      link.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse') display(chosen);
      });
      link.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' || !event.isPrimary) return;
        start = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }, { passive: true });
      link.addEventListener('pointerup', event => {
        if (!start || event.pointerId !== start.id) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          chosen = dx < 0 ? 1 : 0;
          display(chosen);
          lastSwipe = performance.now();
        }
      }, { passive: true });
      link.addEventListener('pointercancel', () => { start = null; }, { passive: true });
      link.addEventListener('click', event => {
        if (performance.now() - lastSwipe < 450) event.preventDefault();
      });
    });
    scope.querySelectorAll('.stm-card--swap').forEach(card => {
      if (card.dataset.stmImageReady) return;
      card.dataset.stmImageReady = 'true';
      const image = card.querySelector('.stm-image-action');
      if (!image) return;
      const ready = () => card.classList.toggle('is-action-ready', image.complete && image.naturalWidth > 0);
      image.addEventListener('load', ready);
      image.addEventListener('error', () => card.classList.remove('is-action-ready'));
      card.addEventListener('pointerenter', () => { image.loading = 'eager'; ready(); });
      ready();
    });
    scope.querySelectorAll('[data-stm-shop]').forEach(menu => {
      if (menu.dataset.stmReady) return;
      menu.dataset.stmReady = 'true';
      const summary = menu.querySelector(':scope > summary');
      if (!summary) return;
      let opening;
      let closing;
      let suppressed = false;
      const cancel = () => { clearTimeout(opening); clearTimeout(closing); };
      summary.addEventListener('click', cancel);
      const close = (restore = false) => {
        cancel(); menu.open = false;
        if (restore) summary.focus({ preventScroll: true });
      };
      menu.querySelectorAll('[data-stm-close]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => { suppressed = true; close(true); });
      });
      menu.addEventListener('toggle', () => {
        if (menu.open) document.querySelectorAll('[data-stm-shop][open]').forEach(other => { if (other !== menu) other.open = false; });
      });
      menu.addEventListener('pointerenter', event => {
        if (menu.dataset.stmShop !== 'desktop' || event.pointerType !== 'mouse' || !finePointer.matches || !desktop.matches || suppressed) return;
        cancel(); opening = setTimeout(() => { if (menu.isConnected) menu.open = true; }, 140);
      });
      menu.addEventListener('pointerleave', event => {
        if (menu.dataset.stmShop !== 'desktop' || event.pointerType !== 'mouse') return;
        suppressed = false; cancel();
        closing = setTimeout(() => { if (!menu.contains(document.activeElement)) close(); }, 260);
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) {
          event.preventDefault(); event.stopPropagation(); suppressed = true; close(true);
        } else if (event.key === 'ArrowDown' && event.target === summary) {
          event.preventDefault(); cancel(); menu.open = true;
          menu.querySelector('.stm-panel a')?.focus();
        }
      }, true);
      menu.addEventListener('focusout', () => {
        setTimeout(() => { if (!menu.contains(document.activeElement)) close(); }, 0);
      });
      document.addEventListener('pointerdown', event => {
        if (menu.isConnected && menu.open && !menu.contains(event.target)) close();
      }, { passive: true });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close()));
      menu.closest('[data-st-menu]')?.addEventListener('toggle', event => { if (!event.target.open) close(); });
      desktop.addEventListener('change', () => close());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
